"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurableItemTypeSelectInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var insurable_item_type_definitions_1 = require("../../hooks/insurable-item-type-definitions");
function InsurableItemTypeSelectInput(_a) {
    var placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange, isClearable = _a.isClearable;
    var _b = insurable_item_type_definitions_1.useInsurableItemTypeDefinitionsHelpers(), insurableItemTypes = _b.insurableItemTypes, renderInsurableItemType = _b.renderInsurableItemType;
    var options = insurableItemTypes.map(function (insurableItemType) { return ({
        label: renderInsurableItemType(insurableItemType),
        value: insurableItemType,
    }); });
    return (react_1.default.createElement(core_ui_1.AdvancedSelectInput, { isClearable: isClearable, options: options, placeholder: placeholder, value: value, onChange: function (newValue) { return onChange(newValue); } }));
}
exports.InsurableItemTypeSelectInput = InsurableItemTypeSelectInput;
